import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

//Fournir le sytle global, comme body, etc
import './index.css'

//Importation des routes du projet
import AppRoutes from './routes/AppRoutes'
import { ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import locale from 'antd/locale/fr_FR'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <ConfigProvider locale={locale}>
      <QueryClientProvider client={queryClient}>
        <AppRoutes />
      </QueryClientProvider>
    </ConfigProvider>
  </BrowserRouter>
)
